/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visual_DnaInputs */

const en_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visual DNA`)
};

const es_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADN Visual`)
};

const fr_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADN Visuel`)
};

const de_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visuelle DNA`)
};

const ja_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビジュアルDNA`)
};

const zh_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视觉 DNA`)
};

const ar_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البصمة المرئية (DNA)`)
};

const id_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA Visual`)
};

const it_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA Visivo`)
};

const ru_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Визуальная ДНК`)
};

const pt_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA Visual`)
};

const ko_visual_dna = /** @type {(inputs: Visual_DnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비주얼 DNA`)
};

/**
* | output |
* | --- |
* | "Visual DNA" |
*
* @param {Visual_DnaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const visual_dna = /** @type {((inputs?: Visual_DnaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visual_DnaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_visual_dna(inputs)
	if (locale === "es") return es_visual_dna(inputs)
	if (locale === "fr") return fr_visual_dna(inputs)
	if (locale === "de") return de_visual_dna(inputs)
	if (locale === "ja") return ja_visual_dna(inputs)
	if (locale === "zh") return zh_visual_dna(inputs)
	if (locale === "ar") return ar_visual_dna(inputs)
	if (locale === "id") return id_visual_dna(inputs)
	if (locale === "it") return it_visual_dna(inputs)
	if (locale === "ru") return ru_visual_dna(inputs)
	if (locale === "pt") return pt_visual_dna(inputs)
	return ko_visual_dna(inputs)
});